export default __webpack_public_path__ + "static/media/ParkIcon.5706e5fc.svg";